export default "/images/7a4a4206cfb01cd4be61a8715131c2c3.avif";